export const OBTENER_SALIDAS_VEHICLES = "obtener_salidas_vehiculos";
export const CARGANDO_SALIDAS_VEHICLES = "cargando_salidas_vehiculos";
export const ERROR_SALIDAS_VEHICLES = "error_salidas_vehiculos";

export const OBTENER_SALIDAS_STATUS = "obtener_salidas_estados";
export const CARGANDO_SALIDAS_STATUS = "cargando_salidas_estados";
export const ERROR_SALIDAS_STATUS = "error_salidas_estados";
